// Fuente ÚNICA (10.1) de "la entidad de un usuario según su rol", resuelta SIEMPRE por ID
// (10.7): rol `agencia` → intermediario (`usuarios.agencia`), rol `cliente` → cliente
// (`usuarios.cliente_id`), rol `edificio` → edificio(s) (`usuarios.edificiosOk`, CSV de ids;
// si hay varios muestra el primero + " +N"). Antes esta lógica vivía inline y duplicada en
// `src/pages/Usuarios/index.js` (columna Agencia/Cliente + su sort); ahora la comparten esa
// pantalla y el banner de cumpleaños del Home.
//
// Si la entidad no resuelve, devuelve "" — el consumidor decide el fallback visual (un "-" en
// la tabla, solo el nombre en el banner); nunca inventa un nombre ni arma un string con basura.

// Etiqueta de un cliente: "Empresa | Producto", o su nombre si empresa === producto (idéntico
// a la resolución que existía en Usuarios).
const labelCliente = (cliente) =>
  cliente ? (cliente.empresa === cliente.producto ? cliente.nombre : `${cliente.empresa} | ${cliente.producto}`) : "";

export const resolverEntidadUsuario = (usuario, { clientes = [], intermediarios = [], edificios = [] } = {}) => {
  if (!usuario) return "";

  if (usuario.rol === "cliente") {
    return labelCliente(clientes.find((c) => c.id === usuario.cliente_id));
  }

  if (usuario.rol === "agencia") {
    return intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "";
  }

  if (usuario.rol === "edificio") {
    // edificiosOk = CSV de ids sin espacios (o null). Primero + " +N" si tiene más de uno.
    const ids = String(usuario.edificiosOk || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .map(Number);
    if (ids.length === 0) return "";
    const nombre = edificios.find((e) => e.id === ids[0])?.edificio || "";
    if (!nombre) return "";
    return ids.length > 1 ? `${nombre} +${ids.length - 1}` : nombre;
  }

  return "";
};
